import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  examUserData: [],
  examListData: [],
  totalexamUser: 0,
}

export const examUserSlice = createSlice({
  name: "examUser",
  initialState,
  reducers: {
    setExamUserData(state, { payload }) {
      state.examUserData = payload.result
      state.totalexamUser = payload.total
    },
    setExamListData(state, { payload }) {
      state.examListData = payload
    },
  }
})

export const { setExamUserData, setExamListData } = examUserSlice.actions;

export default examUserSlice.reducer;

export function getExamUser(limit, offset, keyword) {
  return async function getExamUserThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getExamUser(limit, offset, keyword).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setExamUserData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function getExamList(id) {
  return async function getExamListThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getExamList(id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setExamListData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
